import { TFunction } from 'i18next';

export const getTossTabName = (index: number, t: TFunction) => {
  switch (index) {
    case 1:
      return t('0マスタ').toString();
    case 2:
      return t('サービススペック').toString();
    case 3:
      return t('F-List').toString();
    case 4:
      return t('部品表').toString();
    case 5:
      return t('トス資料取得率').toString();
    default:
      return '';
  }
};

export const getTabName = (index: number, t: TFunction) => {
  switch (index) {
    case 1:
      return t('制作管理表').toString();
    case 2:
      return t('日程編集').toString();
    case 3:
      return t('トス資料').toString();
    case 4:
      return t('確認依頼').toString();
    case 5:
      return t('原稿').toString();
    case 6:
      return t('懸案項目').toString();
    case 7:
      return t('翻訳').toString();
    case 8:
      return t('承認').toString();
    default:
      return '';
  }
};
